import { useEffect } from 'react';
import { COOKIES_CONFIG, PATHS } from '@belong/common';
import { Link, Text } from '@belong/ui';
import { Confetti } from 'animations/Confetti/Confetti';
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
import { ShareableBanner } from 'components/Referral/ShareableBanner';
import AccountHeaderContainer from 'containers/AccountHeaderContainer/AccountHeaderContainer';
import LinkBase from 'corecomponents/LinkBase/LinkBase';
import { Timeline } from 'design-system';
import { useModal } from 'hooks/useModal';
import Page from 'layouts/Page/Page';
import { AppGIF } from 'lease-signing-flow-v2/components/app-gif/app-gif';
import { AppQR } from 'lease-signing-flow-v2/components/app-qr/app-qr';
import { AppStoreBadges } from 'lease-signing-flow-v2/components/app-store-badges/app-store-badges';
import { DownloadAppButton } from 'lease-signing-flow-v2/components/download-app-button/download-app-button';
import { LEASE_SIGNING_FLOW_STRINGS } from 'lease-signing-flow-v2/constants/strings';
import { timelineSteps } from 'lease-signing-flow-v2/constants/success';
import { parseCookies } from 'nookies';
import { BASE_PATHS } from 'routes/paths';

export const Success = () => {
  const [loading, , stopLoader] = useModal(true);
  const cookies = parseCookies();

  const comeFromTheMobileApp = Boolean(
    cookies[COOKIES_CONFIG.MOBILE_APP.name] === 'true',
  );

  useEffect(() => {
    setTimeout(() => {
      stopLoader();
    }, 1000);
  }, [stopLoader]);

  if (loading) {
    return <FullPageSpinner />;
  }

  return (
    <Page
      header={!comeFromTheMobileApp}
      headerMainProps={{
        fixed: true,
        navigationComponents: [
          <>
            <LinkBase href={PATHS.SUPPORT}>
              <Text
                fontWeight="semibold"
                className="uppercase hover:text-green"
              >
                GET HELP 24/7
              </Text>
            </LinkBase>
          </>,
          <AccountHeaderContainer key="AccountHeaderContainer" />,
        ],
      }}
    >
      <>
        <Confetti />
        <div className="mt-lg flex w-full justify-center sm:mt-xl">
          <div className="px-2sm sm:max-w-[730px] sm:pr-0">
            <div className="flex flex-col items-center text-center">
              <div className="max-w-[232px] md:max-w-[595px]">
                <Text variant="h3" fontWeight="semibold">
                  {LEASE_SIGNING_FLOW_STRINGS['success.welcome']}
                </Text>
                <Text variant="h3" fontWeight="semibold">
                  {LEASE_SIGNING_FLOW_STRINGS['success.download']}
                </Text>
              </div>
              <div className="mt-xs max-w-[345px] md:max-w-[632px]">
                <Text
                  dangerouslySetInnerHTML={{
                    __html: LEASE_SIGNING_FLOW_STRINGS['success.subtitle'],
                  }}
                />
              </div>
              <div className="mt-2xl w-full">
                <div className="sm:justifiy-start flex flex-col items-center sm:flex-row sm:items-start md:ml-3xl">
                  <AppGIF />
                  <div className="mt-xl w-full sm:hidden">
                    <DownloadAppButton />
                    <div className="mt-xl">
                      <Link href={BASE_PATHS.ACCOUNTS}>
                        {LEASE_SIGNING_FLOW_STRINGS['success.cta']}
                      </Link>
                    </div>
                  </div>
                  <div className="ml-2xl hidden md:block">
                    <div className="flex flex-col justify-items-start pt-2xl">
                      <AppQR />
                      <div className="mt-xl flex flex-col place-items-start">
                        <div className="mb-xl">
                          <AppStoreBadges />
                        </div>
                        <Link href={BASE_PATHS.ACCOUNTS}>
                          {LEASE_SIGNING_FLOW_STRINGS['success.cta']}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="my-2xl w-full">
                <Text variant="h3" fontWeight="semibold">
                  {LEASE_SIGNING_FLOW_STRINGS['success.timeline.title']}
                </Text>
                <div className="mt-xl flex w-full justify-center">
                  <Timeline
                    alternate
                    checkedNode={
                      <div className="h-[8px] w-[8px] rounded border-2 border-navy bg-green" />
                    }
                    items={timelineSteps}
                    showUncheckedAsDisabled
                    uncheckedNode={
                      <div className="absolute h-[14px] w-[14px] rounded border-2 border-solid border-dark-gray" />
                    }
                  />
                </div>
              </div>
              <div className="mb-5xl flex w-full">
                <ShareableBanner
                  body={LEASE_SIGNING_FLOW_STRINGS.shareableInfo.bannerMessage}
                  shareableMessage={
                    LEASE_SIGNING_FLOW_STRINGS.shareableInfo.shareableMessage
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </>
    </Page>
  );
};
